// src/app/router/ui/PageLoader.jsx
import React from 'react';

export const PageLoader = () => (
  <div className="flex-center flex-col" style={{ minHeight: '400px' }}>
    <div className="loading-spinner"></div>
    <p className="text-sm animate-pulse" style={{ marginTop: 'var(--spacing-md)' }}>ЗАГРУЗКА...</p>
  </div>
);
